/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { CdkMenuModule } from "@angular/cdk/menu";
import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, inject, input, OnInit } from "@angular/core";
import { ClickOutside } from "ngxtension/click-outside";
import { ActionSheetService } from "../../action-sheet/action-sheet.service";
import { Button } from "../../button/button.component";
import { controlValueAccessorProvider } from "../../common/value-accessor";
import { Input } from "../../input/input.component";
import { Label } from "../../label/label.component";
import { Menu } from "../../menu/menu.component";
import { SelectOutput } from "../option/select-option.adapter";
import { SelectAdapter } from "../select.adapter";
import { SelectInput } from "../select.component";
import { SelectStore } from "../select.store";
import { MultipleSelectOption } from "./multiple-select-option/multiple-select-option.component";
import { MultipleSelectSelectedItem } from "./selected-item/multiple-select-selected-item.component";

@Component({
    host: {
        ngSkipHydration: "true",
    },
    selector: "app-multiple-select",
    styleUrls: [
        "../../input/input.component.scss",
        "./multiple-select.component.scss",
    ],
    standalone: true,
    imports: [
        CommonModule,
        Input,
        Label,
        MultipleSelectSelectedItem,
        MultipleSelectOption,
        ClickOutside,
        Button,
        CdkMenuModule,
        Menu,
    ],
    templateUrl: "./multiple-select.component.html",
    providers: [SelectStore, controlValueAccessorProvider(MultipleSelect)],
})
export class MultipleSelect
    extends SelectAdapter<any[]>
    implements OnInit, AfterViewInit, SelectInput
{
    readonly actionSheetService = inject(ActionSheetService);

    renderItem = input<any>();
    prefixIcon = input<string>();
    suffixIcon = input<string>();
    modalTitle = input<string>();

    override handleSelect({ value }: SelectOutput) {
        this.open.set(false);

        if (this.value()?.includes(value)) {
            this.value.set(this.value()?.filter((v) => v !== value));
        } else {
            this.value.set([...(this.value() || []), value]);
        }
    }

    /**
     * @description action sheet 열기(모바일에서만 사용)
     */
    handleActionSheet(ev: Event) {
        if (!this.isMobile()) return;
        ev.stopPropagation();
        ev.preventDefault();

        setTimeout(() => {
            const sheet = this.actionSheetService.create({
                multiple: true,
                options: this.options().map((option) => {
                    return {
                        label: this.store.getLabel(option, this.bindLabel()!),
                        value: this.store.getValue(option, this.bindValue()!),
                    };
                }),
                title: this.modalTitle()
                    ? this.modalTitle()
                    : this.label()
                      ? `${this.label()} 선택`
                      : "선택",
                renderItem: this.renderItem(),
                currentValue: this.value(),
            });

            sheet.closed.subscribe((res) => {
                if (res === "cancel") return;

                this.value.set(res);
            });
        });
    }

    handleRemove(value: string) {
        this.value.set(this.value()?.filter((v) => v !== value));
    }

    override handleOpen(ev?: any) {
        if (ev) {
            ev.stopPropagation();
            ev.preventDefault();
        }

        if (!this.isMobile()) {
            this.open.set(true);
        } else {
            this.handleActionSheet(ev);
        }
    }
}
